import { motion } from "framer-motion";
import { useSite } from "../../context/SiteContext";

export const About = () => {
  const { site } = useSite();
  const s = site?.settings || {};
  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="relative z-10 py-20 lg:py-28 border-t border-[#232530]"
      data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-4">
          <div className="image-frame arch-top overflow-hidden">
            <img src={s.portrait_url} alt={s.owner_name}
              className="w-full h-[420px] object-cover grayscale-[30%] contrast-110 arch-top"
              data-testid="about-portrait" />
          </div>
        </div>
        <div className="lg:col-span-8">
          <p className="font-mono text-xs tracking-[0.35em] uppercase text-[#581313] mb-4">05 // THE KEEPER</p>
          <h2 className="font-serif font-light text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#ede8e1]" data-testid="about-owner-name">
            {s.owner_name}
          </h2>
          <p className="mt-6 max-w-2xl text-lg font-light text-[#a8a29e] leading-relaxed" data-testid="about-bio">
            {s.bio}
          </p>
          <p className="mt-8 font-mono text-[11px] tracking-[0.3em] uppercase text-[#78716c]">{s.location_label}</p>
        </div>
      </div>
    </motion.section>
  );
};
